import type {SubgoalApiModel} from '../../../api/goal';

export const SUBGOAL_ICONS = [
  'goal1',
  'goal2',
  'goal3',
  'goal4',
  'goal5',
  'goal6',
  'goal7',
  'goal8',
  'goal9',
  'goal10',
  'goal11',
  'goal12',
  'goal13',
  'goal14',
  'goal15',
  'goal16',
  'goal17',
  'goal18',
  'goal19',
  'goal20',
  'goal21',
  'goal22',
  'goal23',
  'goal24',
  'goal25',
  'goal26',
  'goal27',
  'goal28',
  'goal29',
  'goal30',
  'goal31',
  'goal32',
  'goal33',
  'goal34',
  'goal35',
  'goal36',
  'goal37',
  'goal38',
  'goal39',
  'goal40',
  'goal41',
  'goal42',
  'goal43',
  'goal44',
] as const;

export type SubgoalIcon = (typeof SUBGOAL_ICONS)[number] | null;

export const getSubgoalIcon = (icon: SubgoalApiModel['icon']) => {
  switch (icon) {
    case 'goal1':
      return require('../../../assets/icons/goals/1.svg').default;
    case 'goal2':
      return require('../../../assets/icons/goals/2.svg').default;
    case 'goal3':
      return require('../../../assets/icons/goals/3.svg').default;
    case 'goal4':
      return require('../../../assets/icons/goals/4.svg').default;
    case 'goal5':
      return require('../../../assets/icons/goals/5.svg').default;
    case 'goal6':
      return require('../../../assets/icons/goals/6.svg').default;
    case 'goal7':
      return require('../../../assets/icons/goals/7.svg').default;
    case 'goal8':
      return require('../../../assets/icons/goals/8.svg').default;
    case 'goal9':
      return require('../../../assets/icons/goals/9.svg').default;
    case 'goal10':
      return require('../../../assets/icons/goals/10.svg').default;
    case 'goal11':
      return require('../../../assets/icons/goals/11.svg').default;
    case 'goal12':
      return require('../../../assets/icons/goals/12.svg').default;
    case 'goal13':
      return require('../../../assets/icons/goals/13.svg').default;
    case 'goal14':
      return require('../../../assets/icons/goals/14.svg').default;
    case 'goal15':
      return require('../../../assets/icons/goals/15.svg').default;
    case 'goal16':
      return require('../../../assets/icons/goals/16.svg').default;
    case 'goal17':
      return require('../../../assets/icons/goals/17.svg').default;
    case 'goal18':
      return require('../../../assets/icons/goals/18.svg').default;
    case 'goal19':
      return require('../../../assets/icons/goals/19.svg').default;
    case 'goal20':
      return require('../../../assets/icons/goals/20.svg').default;
    case 'goal21':
      return require('../../../assets/icons/goals/21.svg').default;
    case 'goal22':
      return require('../../../assets/icons/goals/22.svg').default;
    case 'goal23':
      return require('../../../assets/icons/goals/23.svg').default;
    case 'goal24':
      return require('../../../assets/icons/goals/24.svg').default;
    case 'goal25':
      return require('../../../assets/icons/goals/25.svg').default;
    case 'goal26':
      return require('../../../assets/icons/goals/26.svg').default;
    case 'goal27':
      return require('../../../assets/icons/goals/27.svg').default;
    case 'goal28':
      return require('../../../assets/icons/goals/28.svg').default;
    case 'goal29':
      return require('../../../assets/icons/goals/29.svg').default;
    case 'goal30':
      return require('../../../assets/icons/goals/30.svg').default;
    case 'goal31':
      return require('../../../assets/icons/goals/31.svg').default;
    case 'goal32':
      return require('../../../assets/icons/goals/32.svg').default;
    case 'goal33':
      return require('../../../assets/icons/goals/33.svg').default;
    case 'goal34':
      return require('../../../assets/icons/goals/34.svg').default;
    case 'goal35':
      return require('../../../assets/icons/goals/35.svg').default;
    case 'goal36':
      return require('../../../assets/icons/goals/36.svg').default;
    case 'goal37':
      return require('../../../assets/icons/goals/37.svg').default;
    case 'goal38':
      return require('../../../assets/icons/goals/38.svg').default;
    case 'goal39':
      return require('../../../assets/icons/goals/39.svg').default;
    case 'goal40':
      return require('../../../assets/icons/goals/40.svg').default;
    case 'goal41':
      return require('../../../assets/icons/goals/41.svg').default;
    case 'goal42':
      return require('../../../assets/icons/goals/42.svg').default;
    case 'goal43':
      return require('../../../assets/icons/goals/43.svg').default;
    case 'goal44':
      return require('../../../assets/icons/goals/44.svg').default;
    default:
      return require('../../../assets/icons/cup.svg').default;
  }
};
